import { initialState, AlertSlice } from './Slice'
import { AlertState } from './Type'

export { initialState, AlertSlice }
export type { AlertState }

export default AlertSlice.reducer
